import axios from "axios"

const login = (context, data) => {
  context.commit("SET_CURRENT_USER", {
    user: data,
    token: token
  })
}

const logout = (context, vm) => {
  context.commit("SET_CURRENT_USER", {})
  localStorage.removeItem("__crrntUser")
  vm.$router.push("/auth/no/login")
}

const updateUserState = (context, vm) => {
  let user = localStorage.getItem("__crrntUser")

  if (user) {
    user = JSON.parse(user)
    let token = user.accessToken

    axios({
      method: "get",
      url: vm.API_URL + "auth/user"
    })
      .then((res) => {
        context.commit("SET_CURRENT_USER", {
          user: res.data.data,
          token: token
        })
      })
      .catch((err) => {
        return false
      })
  }
}

export default {
  login,
  logout,
  updateUserState
}
